import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Form,
  Input,
  InputNumber,
  Button,
  Select,
  DatePicker,
  Checkbox,
  message,
  Card,
  Typography,Modal 
} from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { API_BASE_URL } from '../../utils/BaseUrl';

const { Title } = Typography;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const durationTypeOptions = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Annually', value: 'Annually' },
  { label: 'Premiere', value: 'Premiere' },
  { label: 'Buoi', value: 'Buoi' },
];

const statusOptions = [
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
];

const CreatePackageForm = () => {
  const { gymId } = useParams();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
const [modalVisible, setModalVisible] = useState(false);
const navigate = useNavigate();



  const onFinish = async (values) => {
  setLoading(true);
  try {
    const formatDateOnly = (date) => {
  return date ? date.format('YYYY-MM-DD') : null;
};

const payload = {
  GymId: parseInt(gymId),
  Name: values.name || '',
  Price: values.price || 0,
  DurationType: values.durationType || 'Monthly',
  DurationValue: values.durationValue || 1,
  DiscountPercent: values.discountPercent || 0,
  StartDate: formatDateOnly(values.dateRange?.[0]),
  EndDate: formatDateOnly(values.dateRange?.[1]),
  Status: values.status || 'Inactive',
  Features: values.features || '',
  IsPopular: values.isPopular || false,
};


    await axios.post(`${API_BASE_URL}/api/Package/create_Package`, payload);

    message.success('Tạo gói tập thành công!');
    
    // Hiện modal hỏi người dùng có muốn tạo thêm không
    Modal.confirm({
  title: 'Bạn có muốn tạo thêm gói tập nữa không?',
  okText: 'Có',
  cancelText: 'Không',
  onOk: () => {
    form.resetFields();
    window.location.reload(); // Reset lại toàn bộ trang (dính dữ liệu phụ cũng reset)
  },
  onCancel: () => {
    Modal.info({
      title: 'Vui lòng chờ admin phê duyệt phòng gym của bạn.',
      content: 'Chúng tôi sẽ thông báo khi phòng gym được phê duyệt.',
      okText: 'Đã hiểu',
      onOk: () => {
      navigate(`/gym-status/${gymId}`);
    },
    });
  },
});


  } catch (error) {
    message.error('Tạo gói tập thất bại: ' + (error.response?.data?.message || error.message));
  }
  setLoading(false);
};


  return (
    <Card
      style={{
        maxWidth: 600,
        margin: 'auto',
        marginTop: 40,
        borderRadius: 12,
        boxShadow: '0 4px 24px #1890ff22',
      }}
    >
      <Title level={3} style={{ textAlign: 'center', color: '#1890FF' }}>
        Tạo Gói Tập cho phòng tập Fitness
      </Title>

      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          status: 'Inactive',
          isPopular: false,
        }}
      >
        <Form.Item
          label="Tên gói tập"
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên gói tập!' }]}
        >
          <Input placeholder="Nhập tên gói tập" />
        </Form.Item>

        <Form.Item
          label="Giá (VNĐ)"
          name="price"
          rules={[{ required: true, message: 'Vui lòng nhập giá!' }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} placeholder="Nhập giá" />
        </Form.Item>

        <Form.Item
          label="Loại thời hạn"
          name="durationType"
          rules={[{ required: true, message: 'Chọn loại thời hạn!' }]}
        >
          <Select options={durationTypeOptions} placeholder="Chọn loại thời hạn" />
        </Form.Item>

        <Form.Item
          label="Giá trị thời hạn"
          name="durationValue"
          rules={[{ required: true, message: 'Nhập số tháng/ngày/buổi!' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} placeholder="Ví dụ: 1, 12, 30" />
        </Form.Item>

        <Form.Item label="Phần trăm giảm giá (%)" name="discountPercent">
          <InputNumber min={0} max={100} style={{ width: '100%' }} placeholder="Tùy chọn" />
        </Form.Item>

        <Form.Item
          label="Thời gian áp dụng"
          name="dateRange"
          rules={[{ required: true, message: 'Chọn thời gian bắt đầu và kết thúc!' }]}
        >
          <RangePicker style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Trạng thái"
          name="status"
          rules={[{ required: true, message: 'Chọn trạng thái!' }]}
        >
          <Select options={statusOptions} placeholder="Chọn trạng thái" />
        </Form.Item>

        <Form.Item label="Tính năng đi kèm" name="features">
          <TextArea rows={3} placeholder="VD: Sử dụng toàn bộ máy, Hướng dẫn viên cá nhân, ..." />
        </Form.Item>

        <Form.Item name="isPopular" valuePropName="checked">
          <Checkbox>Đánh dấu là gói phổ biến</Checkbox>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Tạo gói tập
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default CreatePackageForm;
